"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBoilingPoint = getBoilingPoint;
const deepmerge_1 = __importDefault(require("deepmerge"));
const physical_parser_1 = require("physical-parser");
const extractExperimentalData_1 = require("./extractExperimentalData");
/**
 * Returns the boiling point of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @param options Options for the compound
 * @returns ExperimentalData
 */
function getBoilingPoint(data, options = {}) {
    const boilingPoint = (0, extractExperimentalData_1.extractExperimentalData)(data, 'Boiling Point', {
        parser: (value) => (0, physical_parser_1.parseBoilingPoint)(value, (0, deepmerge_1.default)({
            pressure: { defaultValue: 760, defaultUnits: 'torr' },
        }, options)),
    });
    return boilingPoint;
}
//# sourceMappingURL=getBoilingPoint.js.map